<template>
  <div class="flex sm12 xs12">
    <span id="p-add-up">
      <PrizesAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateData="updateData"
        :raffleId="raffleId"
      />
    </span>
    <va-card :title="$t('raffles.prizes.cards.title')">
      <template slot="actions">
        <va-button
          @click="open"
          icon="fa fa-plus"
          href="#p-add-up"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="prizes"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template
          slot="actions"
          slot-scope="props"
        >
          <va-popover :message="`${$t('raffles.tooltips.updatePrize')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href="#p-add-up"
              @click="update(props.rowData)"
            />
          </va-popover>
          <va-popover :message="`${$t('tooltips.delete')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('raffles.modals.message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deletingUpload"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import PrizesAddUpdate from './PrizesAddUpdate'
const perPage = 10
export default {
  name: 'Prizes',
  components: {
    PrizesAddUpdate,
  },
  props: {
    raffleId: {
      required: true,
    },
  },
  data () {
    return {
      perPage: perPage,
      prizes: [],
      page: 1,
      showAdd: false,
      pages: null,
      loading: false,
      modalDeletar: false,
      deleteId: 0,
      titleCard: '',
      updateData: null,
    }
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'name',
        title: this.$t('raffles.prizes.headings.name'),
        width: '30%',
      }, {
        name: 'description',
        title: this.$t('raffles.prizes.headings.description'),
        width: '50%',
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  apollo: {
    prizes: {
      query: gql`
      query MyQuery($page: Int, $perPage: Int, $raffleId: Int!) {
        prizes: prize(limit: $perPage, offset: $page, order_by: {id: asc}, where: {raffle_id: {_eq: $raffleId}}) {
          id
          name
          description
          raffle_id
        }
      }
      `,
      variables () {
        return {
          perPage: this.perPage,
          page: 0,
          raffleId: this.raffleId,
        }
      },
    },
    pages: {
      query: gql`
      query MyQuery($raffleId: Int!) {
        pages: prize_aggregate(where: {raffle_id: {_eq: $raffleId}})  {
          aggregate {
            count
          }
        }
      }
      `,
      variables () {
        return {
          raffleId: this.raffleId,
        }
      },
    },
  },
  methods: {
    close (v) {
      this.showAdd = v
      this.updateData = null
    },
    update (data) {
      this.titleCard = 'update'
      this.updateData = data
      this.showAdd = true
    },
    open () {
      this.updateData = null
      this.showAdd = true
      this.titleCard = 'create'
    },
    showModal (data) {
      this.modalDeletar = true
      this.deleteId = data
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.prizes.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
          raffleId: this.raffleId,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deletingUpload () {
      const self = this
      this.$axios.delete(
        '/api/upload',
        {
          data: {
            file: this.deleteId.image,
            path: 'prizes',
          },
        },
      ).then(resp => {
        self.deleting()
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_prize_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId.id,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style>

</style>
